import type Luminary from '@lumen5/luminary';

import type { VideoColorMap } from 'js/src/data/app';

/**
 *
 * traverses the video and returns an array of Record<string, number> with the following shape
 *
 * {
 *   color_0: 2837378,
 * }
 *
 * the key specifies the index in the palette, and the value is the color
 * value represented as a base 10 number
 */
export function getVideoColors(luminary: Luminary | Readonly<Luminary>): VideoColorMap {
    return luminary.template.colors.map((color, colorIndex) => ({
        [`color_${colorIndex}`]: color.color,
    }));
}

/**
 * we need to extract the selected color index (for example '1' from 'color_1')
 * and transform it to int in order to pass into the set function. This reverses the
 * index created in getVideoColors.
 */
export function extractIndexFromColorLabel(color: string): number {
    return parseInt(color.split('_')[1]);
}
